<fs-logo [type]="getProductType()" (onPress)="pressed()"></fs-logo>